import type React from 'react';

import { DepartmentUser } from '@vlabs/monokit/entities/users/department-user';
import { AttachDepartmentUsersButton, DetachDepartmentUsersIconButton } from '@vlabs/monokit/features';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import { useDepartmentUserListTranslation } from './i18n';
import { useGetUsers } from '@vlabs/api/artemy/client';
import { FoldableEntity } from '../../../shared/ui/foldable-entity';
import type { FoldableEntityProps } from '../../../shared/ui/foldable-entity';

interface DepartmentUserListProps extends Pick<FoldableEntityProps, 'actions'> {
  departmentId: DepartmentId;
}

function DepartmentUserList({
  departmentId,
  ...props
}: DepartmentUserListProps): React.JSX.Element {
  const { t } = useDepartmentUserListTranslation();
  const { data } = useGetUsers({ department_id: departmentId });

  return (
    <FoldableEntity
      actions={<AttachDepartmentUsersButton departmentId={departmentId} />}
      heading={t('title')}
      {...props}
    >
      {data?.users.map(({ user_id }) => (
        <DepartmentUser
          actions={[
            <DetachDepartmentUsersIconButton
              departmentId={departmentId}
              key="detach"
              userIds={[user_id]}
            />,
          ]}
          key={user_id}
          userId={user_id}
        />
      ))}
    </FoldableEntity>
  );
}

export { DepartmentUserList };
